import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { toast } from 'react-toastify';
import axios from 'axios';
import CustomBackdrop from '../../../../components/backdrop';
import getEnvironement from '../../../../environnement';
import CustomInput from '../../../../components/customInput';

export default function UpdateDialog({
  open,
  handleOpen,
  handleClose,
  reloadData,
  materielData,
}) {
  const [materiel, setMateriel] = useState(materielData?.materiel);
  const [materielEn, setMaterielEn] = useState(materielData?.materiel_en);
  const [materielError, setMaterielError] = useState('');
  const [materielEnError, setMaterielEnError] = useState('');
  const [openBackdrop, setOpenBackdrop] = useState(false);

  async function editMateriel() {
    const url = `${getEnvironement().API_URL}/materiels/${materielData.id}`;
    const data = {
      materiel,
      materielEn
    };
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    handleClose();
    setOpenBackdrop(true);
    await axios.put(url, data, config)
      .then(() => setTimeout(() => setOpenBackdrop(false), 800))
      .then(() => reloadData())
      .then(() => setTimeout(() => toast.success('Le matériel a bien été modifié'), 800))
      .catch((err) => {
        setOpenBackdrop(false);
        if (err.response.data.errors) {
          err.response.data.errors.materiel ? setMaterielError(err.response.data.errors.materiel[0]) : setMaterielError('');
          err.response.data.errors.materielEn ? setMaterielEnError(err.response.data.errors.materielEn[0]) : setMaterielEnError('');
          handleOpen();
        }
      });
  }

  useEffect(() => {
    if (open) {
      setMateriel(materielData?.materiel);
      setMaterielEn(materielData?.materiel_en);
    }
    if (!open) {
      setMaterielError('');
      setMaterielEnError('');
    }
  }, [materielData?.materiel, materielData?.materiel_en, open]);

  return (
    <>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{paddingBottom: '0px'}}
      >
        <DialogTitle id="alert-dialog-title">
          <p className='text-2xl sm:text-3xl font-medium font-inter mt-5'>Matériel pédagogique : {materielData?.id}</p>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <CustomInput
              type='text'
              placeholder='Matériel pédagogique'
              value={materiel}
              setValue={setMateriel}
              isError={materielError !== ''}
              error={materielError}
            />
            <CustomInput
              type='text'
              placeholder='Matériel pédagogique (anglais)'
              value={materielEn}
              setValue={setMaterielEn}
              isError={materielEnError !== ''}
              error={materielEnError}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className='flex justify-between px-5 w-full gap-5'>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 px-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={handleClose}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Annuler</p>
            </div>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 px-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={editMateriel}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Confirmer</p>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
